import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import Career from "../screens/users/Career";
import ServiceDetailPage from "../components/User/Service/Servicedetailpage";
import FAQs from "../screens/users/FAQs";
import IndustryCards from "../screens/users/IndustryDetail";
import Leadership from "../screens/users/Leadership";
import Partners from "../screens/users/Partners";
import Events from "../screens/users/Events";
import Products from "../screens/users/Products";
import ProductDetails from "../components/User/Products/ProductDetails";
import TermsAndPrivacy from "../components/common/Termsandprivacy";
import BlogDetails from "../components/User/Home/Blogdetails";

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/career",
    component: <Career />,
  },
  {
    path: "/faq",
    component: <FAQs />,
  },
  {
    path: "/industries/:slug",
    component: <IndustryCards />,
  },
  {
    path: "/leadership",
    component: <Leadership />,
  },
  {
    path: "/partner",
    component: <Partners />,
  },
  {
    path: "/events",
    component: <Events />,
  },
  {
    path: "/blogDetails/:id",
    component: <BlogDetails />,
  },
  {
    path: "/termsandprivacy",
    component: <TermsAndPrivacy />,
  },
  {
    path: "/products",
    component: <Products />,
  },
  {
    path: "/product/:slug",
    component: <ProductDetails />,
  },
  {
    path: "/service/:id",
    component: <ServiceDetailPage />,
  },
];
